import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { formatAmountCents } from '../../utils/billingPaymentFlow';
import { StripeElementsWrapper } from './VolksignStripeProvider';
import StripePaymentForm from './StripePaymentForm';

const BillingPaymentModal = ({
  show,
  onHide,
  title,
  amountCents,
  currency = 'usd',
  clientSecret,
  submitLabel = 'Pay',
  returnUrl,
  showSaveOptions = false,
  savePaymentMethod = true,
  onSavePaymentMethodChange,
  setAsDefault = true,
  onSetAsDefaultChange,
  onSuccess,
  onError,
  backdrop = 'static',
}) => {
  const formatted = formatAmountCents(amountCents, currency);

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop={backdrop}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {formatted && (
          <p className="text-muted small mb-3">
            Amount due:
            {' '}
            <strong>{formatted}</strong>
          </p>
        )}

        {!clientSecret && (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        {clientSecret && (
          <StripeElementsWrapper clientSecret={clientSecret}>
            <StripePaymentForm
              mode="payment"
              submitLabel={submitLabel}
              returnUrl={returnUrl}
              showSaveOptions={showSaveOptions}
              savePaymentMethod={savePaymentMethod}
              onSavePaymentMethodChange={onSavePaymentMethodChange}
              setAsDefault={setAsDefault}
              onSetAsDefaultChange={onSetAsDefaultChange}
              onSuccess={onSuccess}
              onError={onError}
            />
          </StripeElementsWrapper>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default BillingPaymentModal;
